import { createFileRoute, redirect } from "@tanstack/react-router";

// /patrols/$patrolId now resolves through the Guard Tours flow. We can't
// 1:1 map a patrol id to a guard-tour id (different domains), so we send
// users to the Guard Tours hub where active runs and history are listed.
export const Route = createFileRoute("/_authenticated/patrols/$patrolId")({
  beforeLoad: () => {
    throw redirect({ to: "/guard-tours", replace: true });
  },
  component: () => null,
});
